import { SwitchWitch, switchImages } from 'switch-witch'
import moment from 'moment'
import Swiper from 'swiper/dist/js/swiper'
import { groupBy, compose, map } from 'lodash/fp'

const sww = new SwitchWitch(768)
switchImages(sww.isMobile())
sww.onLayoutChange(switchImages)

//$('.en').remove()


$('a[href=""]').removeAttr('href').addClass('no-link')

// $('#navigator .nav-item').each(function() {
// 	const currentURL = window.location.href.replace(/http(s?):/, '')
// 	if(currentURL.indexOf('exhibit/') > -1){
// 		$('#navigator .nav-item:eq(0)').addClass('-current')
// 	}
// 	if(currentURL.indexOf('program/') > -1){
// 		$('#navigator .nav-item:eq(1)').addClass('-current')
// 	}
// 	if(currentURL.indexOf('guide/') > -1){
// 		$('#navigator .nav-item:eq(2)').addClass('-current')
// 	}
// 	if(currentURL.indexOf('press/') > -1){
// 		$('#navigator .nav-item:eq(4)').addClass('-current')
// 	}
// 	if(currentURL.indexOf('contact/') > -1){
// 		$('#navigator .nav-item:eq(5)').addClass('-current')
// 	}
// })

// $('#navigator.nav-public .nav-item').each(function() {
// 	const currentURL = window.location.href.replace(/http(s?):/, '')
// 	if(currentURL.indexOf('about/') > -1){
// 		$('#navigator .nav-item:eq(0)').addClass('current')
// 	}
// 	if(currentURL.indexOf('access/') > -1){
// 		$('#navigator .nav-item:eq(2)').addClass('current')
// 	}
// 	if(currentURL.indexOf('contact/') > -1){
// 		$('#navigator .nav-item:eq(6)').addClass('current')
// 	}
// })

$('.sub-nav-item .link-image').each(function() {
	const href = $(this).attr('href') || ''
	const linkURL = href.replace(/http(s?):/, '')
	const currentURL = window.location.href.replace(/http(s?):/, '')
	if (currentURL === linkURL) {
		$(this).addClass('disabled-link').removeAttr('href')
		return false
	}
})

$('.sp-navigator .sub-nav-item').each(function() {
	const href = $(this).attr('href') || ''
	const linkURL = href.replace(/http(s?):/, '')
	const currentURL = window.location.href.replace(/http(s?):/, '')
	if (currentURL === linkURL) {
		$(this).addClass('disabled-link').removeAttr('href')
		return false
	}
})

const ua = window.navigator.userAgent.toLowerCase()
const isMobile = /iphone/.test(ua)||/android(.+)?mobile/.test(ua)
if (!isMobile) $('a[href^="tel:"]').removeAttr('href').addClass('no-pointer nop');


// スライダー
$('.swiper-slider').each(function() {
	const $pagination = $(this).children('.swiper-pagination').length
		? $(this).children('.swiper-pagination')
		: $(this).next('.swiper-pagination')

	const $navigation = $(this).children('.slide-controller').length
		? $(this).children('.slide-controller')
		: $(this).next('.slide-controller')

	const $nextButton = $navigation.children('.button.next')
	const $prevButton = $navigation.children('.button.prev')

	const autoplay = $(this).data('autoplay')
		? { delay: $(this).data('autoplay') }
		: false

	const swiper = new Swiper(this, {
    spaceBetween: $(this).data('slides-between') || 0,
		slidesPerView: $(this).data('slides-per-view') || 1,
		loop: $(this).data('loop') || false,
		autoplay,
		pagination: {
			el: $pagination,
			type: 'bullets',
			clickable: true,
		},
		breakpoints: {
			'767': {
				slidesPerView: $(this).data('slides-per-view-sp') || 1,
				slidesPerGroup: $(this).data('slides-per-view-sp') || 1,
			}
		},
		navigation: {
			nextEl: $nextButton,
			prevEl: $prevButton,
		},
	})
})

/**
 * イベントハンドラ
 */

// 汎用・トグル要素
$(document).on('click', '.togglable', function() {
	$(this).toggleClass('selected')
})

// 汎用・ラジオ要素
$(document).on('click', '.exclusive-parent > *', function() {
	$(this).parent().children().removeClass('selected')
	$(this).addClass('selected')
})

// 汎用・ターゲットの表示、非表示
$(document).on('click', '.select-target', function() {
	const id = $(this).data('select-target-id')
	const className = $(this).data('select-target-class')
	$('.' + className).removeClass('selected')
	$('#' + id).addClass('selected')
})

// グローバルナビ・マウスオーバー
// $(document).on('mouseenter', '#navigator .nav-item', function() {
// 	const $self = $(this)
// 	let isSameItem = false

// 	if ($self.hasClass('selected')) {
// 		isSameItem = true
// 	} else {
// 		$self.parent().children().removeClass('selected')
// 		$self.addClass('selected')
// 		$('.pc .sub-nav-item').hide()
// 	}

// 	const target = $self.data('sub-nav-item')
// 	if (!target) {
// 		$('#dummy-sub-nav-background')
// 			.addClass('do-fade-out')
// 			.stop(true, true)
// 			.fadeOut(500, 'easeOutQuad', function() {
// 				$(this).removeClass('do-fade-out')
// 			})

// 		return
// 	}

// 	$('#dummy-sub-nav-background')
// 		.removeClass('do-fade-out')
// 		.stop(true, true)
// 		.fadeIn(500, 'easeOutQuad', function() {
// 			if ($(this).hasClass('do-fade-out') || isSameItem) return
// 			$('.pc .sub-nav-item')
// 				.stop(true, true)
// 				.hide()
// 			$(target)
// 				.stop(true, true)
// 				.fadeIn(500, 'easeOutQuad')
// 		})
// })
// $(document).on('mouseleave', '#navigator, .nav-item:not([data-sub-nav-item])', function() {
// 	$('#navigator .nav-item').removeClass('selected')
// 	$('.pc .sub-nav-item')
// 		.stop(true, true)
// 		.fadeOut(500, 'easeOutQuad')
// 	$('#dummy-sub-nav-background')
// 		.addClass('do-fade-out')
// 		.stop(true, true)
// 		.fadeOut(500, 'easeOutQuad', function() {
// 			$(this).removeClass('do-fade-out')
// 		})
// })

// スムーズスクロール
$(document).on('click', '[data-scroll-target]', function() {
	const target = $(this).data('scroll-target')
  const bothCheck = document.querySelectorAll('.global-nav').length == 0 ? $('#header') : $('.global-nav')
	const $navigator = sww.isMobile() ? $('#header') : bothCheck
	const navigatorHeight = $navigator.outerHeight()
	$('html, body').animate({ scrollTop: $(target).offset().top - navigatorHeight }, 500, 'easeOutExpo')
})

// モーダルクローズボタン
$(document).on('click', '.modal-close-button', function(event) {
	$('#modal-container').fadeOut(500, 'easeOutExpo')
})
$(document).on('click', '#modal-container', function() {
	$(this).fadeOut(500, 'easeOutExpo')
})
$(document).on('click', '#modal-container > .inner', function(e) {
  e.stopPropagation();
})
$(document).on('click', '.modal-item', function(event) {
	event.stopPropagation()
})

// モーダルオープンボタン
$(document).on('click', '.modal-open-button', function() {
	const target = $(this).data('target-modal')
	$('.modal-item').addClass('hidden')
	$(target).removeClass('hidden')
	$('#modal-container').fadeIn(125, 'easeOutQuad')
})

// ドロップダウンメニュー
$('.dropdown-button').on('click', function() {
	$('.sp-navigator').toggleClass('open')
	$('.sp-header .header-wrap').toggleClass('open')
  $(this).toggleClass('open')
})

// SP ドロップダウンアイテム 親ナビアイテム
$('.nav-item.selectable').on('click', function() {
	$(this).next().slideToggle('fast')
	$(this).toggleClass('selected')
})

// ドロップダウンメニュー内アンカーリンク
$('.sp-navigator a[data-scroll-target]').on('click', function() {
	$('.sp-navigator').removeClass('open')
	$('.sp-header .header-wrap').removeClass('open')
	$('.dropdown-button').removeClass('open')
})

// タブボタン
const $tabButtons = $('.tab-button-component')
$tabButtons.on('click', function() {
	$(this).parent().children().removeClass('selected')
	$(this).addClass('selected')
	const target = $(this).data('target')
	$(target).parent().children().removeClass('selected')
	$(target).addClass('selected')
})


//$(document).on('click', )

const onScroll = function () {
  const $navigator = $('.global-nav')
  const scrollTop = $(window).scrollTop()
  const navigatorHeight = $navigator.outerHeight()
  const navigatorTop = $navigator.next().offset().top - navigatorHeight || 0
  // const navigatorTop = 0;
  if (scrollTop >= navigatorTop) {
    $navigator?.addClass('fixed')
    $('body').css({ paddingTop: navigatorHeight })
    $('#pagetop').fadeIn(500, 'easeOutExpo')
  } else {
    $navigator?.removeClass('fixed')
    $('body').css({ paddingTop: 0 })
    $('#pagetop').fadeOut(500, 'easeOutExpo')
  }
}
window.addEventListener('DOMContentLoaded', function () {
  const _exists = $('.global-nav');
  if (_exists.length !== 0) {
    $(window).on('scroll', onScroll)
    onScroll()
  }
})

const pageName = window.location.pathname.replace(/.+\/(.+?)\/?$/, '$1')

switch (pageName) {
	case 'seminarprogram': {
		const datasets = $('.schedule-data').map(function() {
			const args = $(this).data('args').split('[delimiter]')
			const column = parseInt(args[1])
			const day = args[8]
			const page = args[9]
			const category = args[10]
			const room = `${category}-${page * 3 + column}`
			const start = `${args[0]}:${args[3] === '1' ? '3' : '0'}0`
			const end = moment(start, 'HH:mm').add(Math.round(Number(args[2]) * 30), 'minutes').format('HH:mm')
			const period = `${start} - ${end}`
			const $elem = $(this).clone()
			return { day, room, $elem, args, period }
		}).get()
		compose(
			map(groupBy(obj => obj.room)),
			groupBy(obj => obj.day)
		)(datasets).map((dayEvents, day) => {
			for (const room in dayEvents) {
				const events = dayEvents[room]
				const eventElems = events.map(({ $elem, period }) => {
					$elem.find('a').prepend(`<p class="period">${period}</p>`)
					return $elem
				})
				$(`#day-${day + 1}-${room}-events`).append(eventElems)
			}
			// console.log(dayEvents)
		})
		$('.sp.single-calendar .events').each(function() {
			if ($(this).children().length === 0) {
				$(this).parent().remove()
			}
		})
		break
	}
	default: {
		break
	}
}
switch (pageName) {
	case 'timetable': {
		const datasets = $('.schedule-data').map(function() {
			const args = $(this).data('args').split('[delimiter]')
			const column = parseInt(args[1])
			const day = args[8]
			const page = args[9]
			const category = args[10]
			const room = `${category}-${page * 3 + column}`
			const start = moment(`${args[0]}:${args[3] * 30 }`, 'HH:mm').format('HH:mm') //=== '1' ? '3' : '0'}0`
			const end = moment(start, 'HH:mm').add((Number(args[2]) * 30), 'minutes').format('HH:mm')
			const period = `${start} - ${end}`
			const $elem = $(this).clone()
			return { day, room, $elem, args, period }
		}).get()
		compose(
			map(groupBy(obj => obj.room)),
			groupBy(obj => obj.day)
		)(datasets).map((dayEvents, day) => {
			for (const room in dayEvents) {
				const events = dayEvents[room]
				const eventElems = events.map(({ $elem, period }) => {
					$elem.find('a').prepend(`<p class="period">${period}</p>`)
					return $elem
				})
				$(`#day-${day + 1}-${room}-events`).append(eventElems)
			}
			// console.log(dayEvents)
		})
		$('.sp.single-calendar .events').each(function() {
			if ($(this).children().length === 0) {
				$(this).parent().remove()
			}
		})
		break
	}
	default: {
		break
	}
}

$(document).ready(function() {
  if ($('#modal-container.-annotation').length) {
    const target = $(this).data('annotation')
    $('.modal-item').addClass('hidden')
    $(target).removeClass('hidden')
    $('#modal-container').fadeIn(260, 'easeOutQuad')
  };
});

// Viewport 768px以上の場合 viewportをデザイン幅で固定(主にiPad対策)
!(function () {
  const viewport = document.querySelector('meta[name="viewport"]');
  function switchViewport() {
    const value =
      window.outerWidth < 768
        ? 'width=device-width,initial-scale=1'
        : 'width=1440';
    if (viewport.getAttribute('content') !== value) {
      viewport.setAttribute('content', value);
    }
  }
  addEventListener('resize', switchViewport, false);
  switchViewport();
})();
